import { createHead, UnheadProvider } from "@unhead/react/client";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import App from "./App.tsx";
import "./index.css";

const head = createHead();

createRoot(document.getElementById("root")!).render(
  <UnheadProvider head={head}>
    <BrowserRouter>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </UnheadProvider>
);
